export default "__VITE_ASSET__707816c2__"